import React from "react";
import { useLocation } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { capitalizeLink } from "../../_helpers/utility-methods";
import { BodySpacer } from "../../components/utilities/body-spacer";

export const Schools = () => {
    const { pathname } = useLocation();
    return (
        <div className="page-body">
           <AppHeader />
           <BodySpacer />
           <div 
                className="page-pic-box"
                style={{backgroundImage:'url(/images/must.png)'}}
            >
                <div className="page-pic-bg">
                    <div className="pre-txt" />
                    <div className="page-bg-text">
                        <p>UEST</p>
                        <p>PARTNER SCHOOLS</p>
                        <div>
                            <button className="path-btn">
                                <a href="/">Home/</a>{capitalizeLink(pathname)}
                            </button>
                        </div>
                    </div>
                    <div className="pre-txt" />
                </div>
            </div>
        </div>
    );
}